import {useSelector} from 'react-redux';
import {useVersioned} from 'coreUtils/adapters/versioned';
import {selectCustomer} from 'coreStore/data/customer';
import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

/**
 * useCustomerMgr custom hook
 */
export default function useCustomerMgr() {
	const {managerRepository} = useGeneralProvider();

	const customer = useSelector((state) => selectCustomer(state));

	return useVersioned(managerRepository.getCustomerMgr(), customer);
}
